
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { restoreSession } from './authSlice';

export const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(restoreSession());
  }, [dispatch]);

  return <>{children}</>;
}; 